<template>
  <div>
    <el-row class="querypanel">
      <el-col :span="24">
        <el-form ref="form"  label-width="120px" label-position="left">
          <el-form-item label="注册日期:" style="margin-top: 10px; margin-left: 20px;">
            <el-date-picker
              v-model="bymemberdate"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd">
            </el-date-picker>
          </el-form-item>
        </el-form>
      </el-col>
      <el-col :span="24">
        <div>
          <el-button style=" margin-left: 10px;" @click="querymember">查询用户</el-button>
          <el-button style=" margin-left: 10px;" @click="addaccount">开通新账号</el-button>
          <el-button style=" margin-left: 10px;" @click="changepwd">修改密码</el-button>
        </div>
      </el-col>
    </el-row>
    <el-row class="querypanel">
      <el-col :span="12">
        <el-table
          stripe
          highlight-current-row
          @current-change="airowchange"
          :data="memberdata"
          ref="multipleTable">
          <el-table-column
            prop="nickname.String"
            width = "200px"
            label="用户昵称">
          </el-table-column>
          <el-table-column
            prop="phone.String"
            label="电话号码">
          </el-table-column>
        </el-table>
      </el-col>
      <el-col :span="8" style="margin-left: 40px;margin-top:20px;">
        <el-form label-width="80px" label-position="left">
          <el-form-item label="用户名">
            <el-input v-model="ai_username" placeholder="请输入您赋予该用户的用户名"></el-input>
          </el-form-item>
          <el-form-item label="密码">
            <el-input v-model="ai_password" type="password" placeholder="请输入您赋予该用户的密码"></el-input>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import Vue from 'vue'
import axios from 'axios'
import '../../../static/css/my.css'
Vue.prototype.$http = axios
var that
export default {
  name: 'PageInfo',
  data () {
    return {
      khid: '',
      memberdata: [],
      bymemberdate: '',
      ai_username: '',
      ai_password: '',
      selectuser: ''
    }
  },
  mounted: function () {
    var v = getCookie('cusid')
    this.khid = v
    that = this
    console.log(that)
  },
  methods: {
    querymember () {
      var qstr = 'cus_id= ' + this.khid
      that.$http({
        url: 'https://api.sqnetsoft.cn/account/getuserlist',
        method: 'post',
        data: {
          whereinfo: {String: qstr, Valid: true}
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.success) {
            console.log(JSON.parse(res.data.data))
            that.memberdata = JSON.parse(res.data.data)
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    airowchange (row) {
      console.log(row)
      this.selectuser = row
      var qstr = 'cus_user_id= ' + this.selectuser.id
      that.$http({
        url: 'https://api.sqnetsoft.cn/account/getaccountlist',
        method: 'post',
        data: {
          whereinfo: {String: qstr, Valid: true}
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.success) {
            if (res.data.data !== '[]') {
              console.log(JSON.parse(res.data.data))
              var userobj = JSON.parse(res.data.data)
              that.ai_username = userobj.username
              that.ai_password = userobj.password
            }
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    addaccount () {
      if (this.selectuser !== '' && this.ai_username !== '' && this.ai_password !== '') {
        console.log('********创建账号**********')
        var accountinfo = {
          username: this.ai_username,
          password: this.ai_password,
          cususerid: this.selectuser.id.toString()
        }
        console.log(accountinfo)
        that.$http({
          url: 'https://api.sqnetsoft.cn/account/aaubai',
          method: 'post',
          data: accountinfo,
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            if (res.data.success) {
              console.log(JSON.parse(res.data.data))
              that.$message({
                type: 'success',
                message: '创建完毕!'
              })
            }
          })
          .catch(function (error) {
            console.log('error' + error)
          })
        console.log('********创建三方账户**********')
        var thirdaccount = {
          cususerid: this.selectuser.id
        }
        that.$http({
          url: 'https://api.sqnetsoft.cn/account/aaubtai',
          method: 'post',
          data: thirdaccount,
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            if (res.data.success) {
              console.log(JSON.parse(res.data.data))
              that.$message({
                type: 'success',
                message: '更新该用户三方账号信息成功!'
              })
            }
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      } else {
        that.$message({
          type: 'info',
          message: '信息填写不完整!'
        })
      }
    },
    changepwd () {
      var accountinfo = {
        username: this.ai_username,
        password: this.ai_password,
        cususerid: this.selectuser.id.toString()
      }
      that.$http({
        url: 'https://api.sqnetsoft.cn/account/changepwd',
        method: 'post',
        data: accountinfo,
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.success) {
            that.$message({
              type: 'success',
              message: '密码变更完毕!'
            })
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    }
  }
}
function getCookie (name) {
  var v = window.document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)')
  return v ? v[2] : null
}
</script>



// WEBPACK FOOTER //
// src/components/account/AccountInfo.vue